<template>
    <div class="header">
        <div class="main flex_start align_items_center flex_wrap">
            <div class="logo">
                <a href="/">
                    <img :src="logo" />
                </a>
            </div>
            <div class="web_tips">
                <img :src="tips_img" />
            </div>
            <div class="search">
                <form method="post" onsubmit="return false;" class="flex_start align_items_center">
                    <input type="text" name="search_key" v-model="search_key" />
                    <button @click="searchBtn()"><img src="@/assets/images/search.png" /></button>
                </form>
            </div>
            <div class="date_time">
                <div v-if="user" class="flex_end align_items_center">
                    <router-link to="/my/index">{{user}}</router-link>
                    <span @click="logout">退出</span>
                </div>
                <router-link to="/my/login" v-else>登录</router-link>
                <p>{{day}} {{week}}</p>
            </div>
        <!--</div>

        <div class="main flex_end align_items_center">-->
            <div class="header_third flex_end align_items_center">
            <div class="third_login flex_start">
                <a v-bind:href="weibo_url" target="_blank" class="flex_start align_items_center">
                    <img src="@/assets/images/weibo.png" />
                    微博
                </a>
                <a v-bind:href="oa_url" target="_blank" class="flex_start align_items_center oa_index">
                    OA入口
                </a>
            </div>
            <div class="english_btn">
                <a v-bind:href="english_url" target="_blank">English</a>
            </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    name: 'Header',
    /*props: {
        msg: String,
        nav: String,
        sub_nav: String,
    },*/
    props: ['msg','nav','sub_nav'],
    data () {
        return {
            logo:'',
            tips_img: '',
            weibo_url: '',
            oa_url: '',
            english_url: '',
            day:'',
            week:'',
            search_key: '',
            user:''
        }
    },
    created: function() {
        this.search_key = '';
        if(this.$route.query)
        {
            if(this.$route.query.search_key)
            {
                this.search_key = this.$route.query.search_key;
            }
        }
        this.$http({
            url: 'index/getCommon',
            method: 'post',
            headers: { "Content-Type": "multipart/form-data" },
            data:{token: localStorage.getItem('user_token')}
        }).then(res => {
            this.logo = res.data.data.logo;
            this.tips_img = res.data.data.tips_img;
            this.weibo_url = res.data.data.weibo_url;
            this.oa_url = res.data.data.oa_url;
            this.english_url = res.data.data.english_url;
            this.day = res.data.data.time;
            this.week = res.data.data.week;
            this.user = res.data.data.user;
        });
    },
    methods: {
        searchBtn: function () {
            let _this = this,
                search_key = _this.search_key;
            if(search_key == '')
            {
                layer.msg('请输入搜索关键词')
                return false;
            }
            window.location.href = '/home/search?search_key=' + search_key;
            /*_this.$router.push({
                path: '/home/search',
                query: {
                    search_key: search_key
                }
            })*/
        },
        logout: function () {
            let _this = this;
            _this.$http({
                url: 'user/logout',
                method: 'post',
                headers: { "Content-Type": "multipart/form-data" },
                data:{token: localStorage.getItem('user_token')}
            }).then(res => {
                if(res.data.code == 1)
                {
                    localStorage.removeItem('user_id');
                    localStorage.removeItem('user_username');
                    localStorage.removeItem('user_nickname');
                    localStorage.removeItem('user_avatar');
                    localStorage.removeItem('user_token');
                    setTimeout(function () {
                        window.location.href = '/';
                    },1000);
                }
                layer.msg(res.data.msg);
            });
        }
    }
}
</script>

<style>
  @import "../assets/css/public.css";
</style>
<style scoped>
    .header{width:100%;display: block;padding:20px 0;}
    .logo{width:290px;min-width:290px;height: 50px;display: block;}
    .web_tips{width:360px;min-width:360px;height: 50px;padding:11px 0;margin-left:55px;margin-right: 42px;display: block;}
    .logo a,.logo img,.web_tips img{width:100%;height: 100%;object-fit: contain;display: block;}
    .search{width:275px;min-width:275px;height: 35px;}
    .search input{width: 233px;height: 35px;line-height: 33px;padding:0 10px;border:1px solid #dedede;font-size: 12px;display: block;color:#000;}
    .search button{width:42px;height: 35px;text-align: center;background: #c40000;display: block;border:none;}
    .search button img{width: 23px;height: 21px;object-fit: contain;display: block;margin:7px auto;}
    .date_time{width:150px;min-width:110px;display: block;color:#666;margin-left:28px;text-align: right;}
    .date_time p{width:100%;text-align: center;font-size:14px;line-height: 14px;display: block;white-space: nowrap;margin-top:5px;}
    .date_time span{text-align: center;font-size:14px;line-height: 16px;display: block;cursor: pointer;}
    .date_time a{text-align: right;max-width: 100px;overflow: hidden;font-size:16px;line-height: 16px;margin-right: 5px;color: #5e8dee;cursor: pointer;}
    .third_login{margin-top:10px;font-size:13px;line-height: 34px;color:#000;}
    .third_login a{color:#000;position:relative;padding:0 7px;}
    .oa_index::before{content:"";width:1px;height: 16px;background: #000;position:absolute;top:50%;left:0;transform: translateY(-50%);}
    .third_login img{width: 34px;height: 28px;object-fit: contain;display: block;}
    .english_btn{width:84px;height: 34px;line-height: 34px;background: #c40000;color:#fff;text-align: center;font-size: 16px;display: block;margin-top:10px;margin-left:30px;}
    .english_btn a{color:#fff;}
    .header_third{width: 100%;}
    @media screen and (max-width: 1240px) {
        .header{padding:20px 2%;}
        .header .main{justify-content: flex-end !important;}
        .logo{max-height: 50px;height:6.66vw;width: auto;min-width: auto;object-fit: contain;display: block;flex-grow: 1;}
        .logo a{display: flex;justify-content: flex-start;}
        .logo a img{width: auto;}
        .web_tips{max-height: 30px;height: 4vw;width:auto;min-width: auto;padding:0;margin:0 10px 0 0 ;}
        .date_time{margin-top:10px;}
    }
    @media screen and (max-width: 540px) {
        .header{padding:4% 2%;}
        .web_tips,.header .search,.header_third{display: none !important;}
        .logo{min-height: 30px;}
    }
    @media screen and (max-width: 540px) {
        .date_time p{font-size:12px;}
        .date_time{margin-left:2%;}
    }
</style>



// WEBPACK FOOTER //
// src/components/header.vue